import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import Plantation from "../../components/plantation/Plantation";

function PlantationPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Plantation | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Plantation"} t={t} />
      <Plantation />
    </>
  );
}

export default PlantationPage;
